/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Deck_Crypt_CountInputs */



/**
* | output |
* | --- |
* | "Crypt ({count})" |
*
* @param {Deck_Crypt_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_crypt_count = /** @type {((inputs: Deck_Crypt_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Crypt_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Crypte (${i?.count})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Cripta (${i?.count})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Cripta (${i?.count})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Cripta (${i?.count})`)
	return /** @type {LocalizedString} */ (`Crypt (${i?.count})`)
});